import { create } from 'zustand';

type AfterPurchaseModalState = {
  buttonText?: string;
  description: string;
  invoiceUrl?: string;
  isError: boolean;
  isOpen: boolean;
  showInvoiceLink: boolean;
};

type AfterPurchaseModalActions = {
  close: () => void;
  openError: (description: string, invoiceUrl?: string, buttonText?: string) => void;
  openSuccess: (description: string, showInvoiceLink?: boolean) => void;
};

type AfterPurchaseModalStore = AfterPurchaseModalActions & AfterPurchaseModalState;

const DEFAULT_STATE: AfterPurchaseModalState = {
  buttonText: '',
  description: '',
  invoiceUrl: '',
  isError: false,
  isOpen: false,
  showInvoiceLink: false,
};

export const useAfterPurchaseModalStore = create<AfterPurchaseModalStore>((set) => ({
  ...DEFAULT_STATE,
  close: () => set(DEFAULT_STATE),
  openError: (description: string, invoiceUrl?: string, buttonText?: string) =>
    set({
      buttonText,
      description,
      invoiceUrl,
      isError: true,
      isOpen: true,
      showInvoiceLink: !!invoiceUrl || !!buttonText,
    }),
  openSuccess: (description: string, showInvoiceLink = false) =>
    set({
      buttonText: '',
      description,
      invoiceUrl: '',
      isError: false,
      isOpen: true,
      showInvoiceLink,
    }),
}));
